import { render, staticRenderFns } from "./BmvLoader.vue?vue&type=template&id=0db2f3e5&scoped=true"
import script from "./BmvLoader.vue?vue&type=script&lang=js"
export * from "./BmvLoader.vue?vue&type=script&lang=js"
import style0 from "./BmvLoader.vue?vue&type=style&index=0&id=0db2f3e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db2f3e5",
  null
  
)

export default component.exports